var map = {
	"./bullet.svg": "1c87",
	"./bullets.svg": "161e",
	"./check.svg": "9cb5",
	"./cross.svg": "207e",
	"./line.svg": "fb81",
	"./spot.svg": "efa6",
	"./vertical-bullets.svg": "861f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c86d";